import React from "react";
import { Stack, Tooltip, Avatar as Image } from "@mui/material";
import UsersIcon from "../../../../../styles/svg/users-icon.svg";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { AddUserDialog } from "./components/AddUserDialog";
import { TooltipName } from "../../../../../utils/Enums";
import AddUsers from "./AddUsers";
import AvatarGroupList from "./components/AvatarGroupList";
import UsersList from "./components/UsersList";
import { useBoardUsersState } from "./hooks/useBoardUsersState";

function Users({
  boardName,
  boardId,
  ownerId,
  showAddUser = true,
  colabratorBoardName,
  isColabrotar = false,
  cardCollabrator,
  handleRemoveColabrotor,
  handleAddColabrotor,
  assigneeUserId = null,
  collaboratorOptions = [],
  canAddCollaborator,
  mobileFilterSelectedUser = [],
  handleMobileFilterUser = () => {},
  setDrawerClose = () => {},
}) {
  const isMobile = useResponsive("down", "md");
  const {
    anchorEl,
    board,
    boardOwnerId,
    boardUsers,
    canManageUsers,
    closeUserList,
    currentBoardUser,
    filterUserById,
    handleAnchorClick,
    handleCloseEditDialog,
    open,
    openEditUserDialog,
    removeSelectedUser,
    selectedUsers,
    setOpenEditUserDialog,
    sortedUsers,
  } = useBoardUsersState({
    boardName,
    boardId,
    ownerId,
    isColabrotar,
    cardCollabrator,
  });

  return (
    <>
      {openEditUserDialog && currentBoardUser && (
        <AddUserDialog
          boardName={board}
          open={openEditUserDialog}
          onClose={handleCloseEditDialog}
          users={boardUsers}
          isUpdateUser={true}
          currentUser={currentBoardUser}
        />
      )}

      <Stack
        className={isColabrotar ? "align-items-start" : "align-items-center"}
      >
        <div
          className={`d-flex justify-content-center align-items-center ${
            isMobile ? "mobile-users-list-updated" : ""
          }`}
        >
          <AvatarGroupList
            users={sortedUsers}
            setAnchorEl={handleAnchorClick}
            isColabrotar={isColabrotar}
            selectedUsers={selectedUsers}
            filterUserById={isMobile ? handleMobileFilterUser : filterUserById}
            boardOwnerId={boardOwnerId}
          />

          <Tooltip
            title={
              isColabrotar
                ? TooltipName.CARD_DETAIL.COLLABRATOR_LIST
                : TooltipName.BOARD_PAGE.USER_LIST
            }
          >
            <Image
              onClick={handleAnchorClick}
              src={UsersIcon}
              key="avatar-12343"
              className="header-avatar cursor-pointer"
            >
              AS
            </Image>
          </Tooltip>

          {sortedUsers.length > 0 && (
            <UsersList
              anchorEl={anchorEl}
              open={open}
              closeUserList={closeUserList}
              users={sortedUsers}
              isColabrotar={isColabrotar}
              ownerId={ownerId}
              filterUserById={
                isMobile ? handleMobileFilterUser : filterUserById
              }
              selectedUsers={
                isMobile ? mobileFilterSelectedUser : selectedUsers
              }
              removeSelectedUser={removeSelectedUser}
              handleRemoveColabrotor={handleRemoveColabrotor}
              setOpenEditUserDialog={setOpenEditUserDialog}
              board={board}
              canManageUsers={canManageUsers}
              setDrawerClose={setDrawerClose}
            />
          )}

          {showAddUser && (
            <AddUsers
              boardName={board}
              users={boardUsers}
              colabratorBoardName={colabratorBoardName}
              isColabrotar={isColabrotar}
              handleAddColabrotor={handleAddColabrotor}
              assigneeUserId={assigneeUserId}
              collaboratorOptions={collaboratorOptions}
              canAddCollaborator={canAddCollaborator}
              canManageUsers={canManageUsers}
            />
          )}
        </div>
      </Stack>
    </>
  );
}

export default Users;
